<template>
  <v-data-table class="v-csv-viewer elevation-1"
                :class="{ 'hide-per-row-menu': hidePerRowMenu }"
                :headers="headers"
                :items="items"
                :hide-default-headers="hideHeaders">
    <template v-slot:headerCell="data">
      <slot name="headerCell" v-bind="data">
        <p class="title black--text font-weight-medium my-0">{{ data.header.value }}</p>
      </slot>
    </template>
    <template v-slot:items="data">
      <slot name="items" v-bind="data">
        <td v-for="(header, header_index) in headers" :key="`header-${header_index}-item-${data.index}`">
          {{ data.item[header.value] }}
        </td>
      </slot>
    </template>
    <template v-if="hasFooter" v-slot:footer>
      <slot name="footer" />
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'CsvViewer',
  props: {
    // The selected header index
    headers: {
      type: Array,
      default () {
        return []
      },
      required: false
    },
    items: {
      type: Array,
      required: true
    },
    hideHeaders: {
      type: Boolean,
      default: false,
      required: false
    },
    hidePerRowMenu: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    hasFooter () {
      return this.$slots.footer !== undefined
    }
  }
}
</script>

<style lang="sass">
.v-csv-viewer
  table
    thead tr th,
    tfoot tr td
      background-color: #eee
    thead th + th,
    tbody td + td,
    tfoot td + td
      border-left: 1px solid #ddd
  &.hide-per-row-menu .v-datatable__actions .v-datatable__actions__select
    display: none
</style>
